import React from 'react';
import { ArrowUpRight, Instagram, Linkedin } from 'lucide-react';
import { FOUNDER_INTRODUCTION, FOUNDER_PROFILE } from '../config/founder';

const FounderIntroduction = () => (
  <section className="relative overflow-hidden border-y border-white/[0.07] bg-[#050706] py-20 md:py-28">
    <div className="hero-grid pointer-events-none absolute inset-0 opacity-20" />
    <div className="relative mx-auto grid max-w-[1200px] items-center gap-10 px-5 md:px-[7.6923%] lg:grid-cols-[minmax(280px,0.8fr)_minmax(0,1.2fr)] lg:gap-16">
      <figure className="relative mx-auto w-full max-w-[390px] lg:mx-0">
        <div className="absolute -inset-3 rounded-[30px] border border-[#00FFD1]/15" />
        <div className="relative aspect-square overflow-hidden rounded-[26px] border border-white/[0.1] bg-white/[0.03] shadow-2xl shadow-black/50">
          <img
            src={FOUNDER_PROFILE.image}
            alt="Mustafa Can Arslan, founder of Webouse"
            width={FOUNDER_PROFILE.imageWidth}
            height={FOUNDER_PROFILE.imageHeight}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-[#00FFD1]/[0.03]" />
        </div>
      </figure>

      <div className="max-w-2xl">
        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.12em] text-[#00FFD1]">
          {FOUNDER_INTRODUCTION.eyebrow}
        </p>
        <h2 className="text-3xl font-semibold leading-tight text-white md:text-5xl">
          {FOUNDER_INTRODUCTION.greeting}
        </h2>
        <div className="mt-6 space-y-5 text-base leading-8 text-white/64 md:text-lg">
          {FOUNDER_INTRODUCTION.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <a
            href={FOUNDER_PROFILE.linkedIn}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl border border-white/[0.1] bg-white/[0.035] px-4 py-3 text-sm font-semibold text-white/72 transition-colors hover:border-[#00FFD1]/35 hover:text-white"
          >
            <Linkedin className="h-4 w-4 text-[#00FFD1]" /> LinkedIn
            <ArrowUpRight className="h-4 w-4 text-white/35" />
          </a>
          <a
            href={FOUNDER_PROFILE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl border border-white/[0.1] bg-white/[0.035] px-4 py-3 text-sm font-semibold text-white/72 transition-colors hover:border-[#00FFD1]/35 hover:text-white"
          >
            <Instagram className="h-4 w-4 text-[#00FFD1]" /> Instagram
            <ArrowUpRight className="h-4 w-4 text-white/35" />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default FounderIntroduction;
